module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5def583480c419619a97dc969d2ab1c2.png";